import { createI18n } from 'vue-i18n'

import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import lb from './locales/lb.json';


// Create my internationalization feature
const i18n = createI18n({
    locale: "en",
    fallbackLocale: "en",
    messages: {de, en, fr, lb},
  // something vue-i18n options here ...
})

export default i18n;